export default __webpack_public_path__ + "static/media/intel-nuc-logo.efa46829.svg";